import React from 'react';
import { Link } from 'gatsby-plugin-react-i18next';

import PropTypes from 'prop-types';
import useLanguage from '../../../../hooks/useLanguage';

import Arrow from '../../../../svg/arr_right_top.svg';
import Star from '../../../../svg/star_non_shadow.svg';

const PackagesModalFooter = ({ open, payHandler }) => {
  const langToggle = useLanguage;

  return (
    <div
      className={
        open ? 'packages-modal__footer is-open' : 'packages-modal__footer'
      }
    >
      <p className="form-terms">
        <span className="form-terms__text">
          {langToggle(
            'Натискаючи на кнопку, ви даєте згоду на обробку ',
            'Нажимая на кнопку, вы даете согласие на обработку'
          )}
        </span>
        <Link to="/privacy-policy/" className="form-terms__link">
          {langToggle('персональних даних', 'персональных данных')}
        </Link>
      </p>
      <div className="form-button__wrapper">
        <button className="form-button" onClick={payHandler}>
          <span className="form-button__icon">
            <Star className="form-button__icon-star" />
            <Arrow className="form-button__icon-arrow" />
          </span>
          <span className="form-button__title-wrapper">
            <span className="form-button__title">
              {langToggle('Замовити пакет', 'Заказать пакет')}
            </span>
          </span>
        </button>
      </div>
    </div>
  );
};

PackagesModalFooter.propTypes = {
  open: PropTypes.bool,
  payInfo: PropTypes.object,
};

export default PackagesModalFooter;
